import { isNull, get } from "lodash"
import locales from "./../../../content.json"

export const checkIsValidWorkTime = data => {
    return validateWorkTimeStep(get(data, ["workTime", "value"], "")) && !data.workTime.isValid
}

export const validateWorkTimeStep = value => {
    return !isNull(value)
}

export const workTimeData = {
    minimum: {
        value: "minimum",
        title: "Less than 10 min",
        title: locales[window.userLang].time_minimum,
        icon: "img/icon-minimum.png"
    },
    normal: {
        value: "normal",
        title: "10-20 min",
        title: locales[window.userLang].time_normal,
        icon: "img/icon-normal.png"
    },
    maximum: {
        value: "maximum",
        title: "More than 20 min",
        title: locales[window.userLang].time_maximum,
        icon: "img/icon-maximum.png"
    },
    vervDecide: {
        value: "vervDecide",
        title: "Let Verv decide",
        title: locales[window.userLang].time_verv_decide,
        icon: "img/icon-vervdecide.png"
    },
}

export const defaultFasting = false